import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);

    this.addEventListener('click', (event) => {
      const accountSignOut = event.target.closest('.account-sign-out');

      if (accountSignOut) {
        document.body.classList.add('open_account');

      }
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   * @param {CustomEvent<{ resource?: { item_count?: number } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = event.detail.resource?.item_count;
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}

(function () {
  // customElements.whenDefined resolves as soon as shopify-account is registered —
  // no timer needed. Once defined, we wait for the shadow root and dialog with a
  // bounded retry (max ~5s) instead of an unbounded setTimeout loop.
  customElements.whenDefined('shopify-account').then(function () {
    const accountButton = document.querySelector('shopify-account');
    if (!accountButton) return;

    let retries = 0;
    const MAX_RETRIES = 20;

    function tryConnect() {
      const shadowRoot = accountButton.shadowRoot;
      if (!shadowRoot || !shadowRoot.querySelector('dialog')) {
        if (++retries < MAX_RETRIES) setTimeout(tryConnect, 250);
        return;
      }
      const dialog = shadowRoot.querySelector('dialog');
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'open') {
            accountButton.classList.toggle('hidden', !dialog.hasAttribute('open'));
          }
        });
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    }

    tryConnect();
  });
})();

document.addEventListener('click', (event) => {
  const signOutBtn = event.target.closest('.account-sign-out-announcement');

  if (signOutBtn) {
    document.body.classList.add('open_account');
  }
});
document.addEventListener('click', (event) => {
  if (
    event.target.closest('.account-sign-out') ||
    event.target.closest('.account-sign-out-announcement')
  ) {
    window.handleAccountTrigger();
  }
});

window.handleAccountTrigger = function() {
  document.body.classList.add('open_account');
};

// prevent wishlist redirect and opwn accounr drawer 
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.btn-save');

  if (btn && btn.getAttribute('data-listener-attached') === 'true') {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    setTimeout(() => {
      handleAccountTrigger();
    }, 1000);

    return false;
  }
}, true);


document.addEventListener(
  "click",
  function (e) {
    const registerBtn = e.target.closest(".yotpo-register-link button");
    if (registerBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.location.href = "/pages/signup";
      return false;
    }

    const loginBtn = e.target.closest(".yotpo-login-link button");
    if (loginBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      window.location.href = "/pages/rewards";
      return false;
    }
  },
  true // Capture phase
);